// extracted by mini-css-extract-plugin
export var legendIndicator = "_cj-1";
export var legendRight = "_cj-0";